var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96514 6.60457C7.25805 6.26986 7.25805 5.72629 6.96514 5.39158L2.46602 0.250448C2.1731 -0.0842611 1.36753 -0.0842611 1.07462 0.250448C0.78171 0.585158 0.70892 1.16471 1.00183 1.49942L4.68482 5.99941L1.07462 10.4994C0.78171 10.8341 0.70892 11.4137 1.00183 11.7484C1.29474 12.0831 2.01959 12.0855 2.3125 11.7508L6.96748 6.60725L6.96514 6.60457Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightSolid);
export default __webpack_public_path__ + "static/media/chevron-right-solid.d3b7a649be01bdeb7d02fe5355e051e3.svg";
export { ForwardRef as ReactComponent };